import { render, staticRenderFns } from "./designMould.vue?vue&type=template&id=03b99092"
import script from "./designMould.vue?vue&type=script&lang=js"
export * from "./designMould.vue?vue&type=script&lang=js"
import style0 from "./designMould.vue?vue&type=style&index=0&id=03b99092&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports